import ajax from '@utils/ajax';

const rootUrl = '/capsiminbox/authoring-platform/create-course';

export const publishVersion = async (data) =>
  await ajax('POST', `${rootUrl}`, JSON.stringify(data));
